
















































import mixins from 'vue-typed-mixins';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import { required , maxLength } from 'vuelidate/lib/validators';
import {ExtensionViewModel} from "@/models/ExtensionViewModel";
import {StatusUpdateViewModel} from "@/models/StatusUpdateViewModel";
import BoxContainer from "@/components/BoxContainer.vue";
import {ReturnDataViewModel} from "@/models/ReturnDataViewModel";

export default mixins( vuelidateMixin ).extend({
  name: "ExtensionApprovalFinal" ,
  components: {
    BoxContainer
  },
  props: {
    extension: {
      type: Object as () => ExtensionViewModel
    }
  },
  data(): {
    statusUpdateViewModel: StatusUpdateViewModel
  }{
    return{
      statusUpdateViewModel: {} as StatusUpdateViewModel
    }
  },
  validations: {
    statusUpdateViewModel: {
      isApproved: {
        required
      },
      otherInfo: {
        required,
        maxLength: maxLength(2000)
      }
    }
  },
  methods: {
    async handleSubmit() {

      const valid = this.isValidWithNotification( this.$v.statusUpdateViewModel );

      if ( valid ) {

        try {
          this.statusUpdateViewModel.itemId = this.extension.extensionId;

          let result = await this.axios.post(
              '/Extensions/UpdateExtensionStatus',
              this.statusUpdateViewModel,
              {headers: {"Content-Type": "application/json"}}
          );
          const data = result.data as unknown as ReturnDataViewModel;

          if ( result.status === 200 ) {
            await this.$router.push({name: "extensions-detail", params: {id: this.extension.extensionId.toString()}});
          }
        }
        catch (err) {
          if ( err.response.status === 400 || err.response.status === 403 || err.response.status === 404 || err.response.status === 409 ) {
            console.log( err.response.data.message );
          }
        }
        finally {
          // do something
        }

      }

    }
  }
} )

